//ComponentName Related
export const DEMO_ACTION_TYPE_ONE = "demo-action-type-one";

//ComponentName Related
export const DEMO_ACTION_TYPE_TWO = "demo-action-type-teo";

//Common
export const RESET_STATE = "reset-store";
export const CLEAR_STATE = "clear-store";
